"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInputActionTypes = void 0;
const NumberInputActionTypes = exports.NumberInputActionTypes = {
  clamp: 'numberInput:clamp',
  inputChange: 'numberInput:inputChange',
  increment: 'numberInput:increment',
  decrement: 'numberInput:decrement',
  decrementToMin: 'numberInput:decrementToMin',
  incrementToMax: 'numberInput:incrementToMax',
  resetInputValue: 'numberInput:resetInputValue'
};